import React from "react";
import { CONTACT_IMG } from "../../lib/assets";

export const ContactAreaInner = () => {
  return (
    <section className="inner-contact-area pt-120 pb-120">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="inner-contact-img">
              <img src={CONTACT_IMG} alt="" style={{width: " 550px", height:"479px", paddingLeft:"20px"}}/>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="inner-contact-info">
              <h2 className="title">Our Office</h2>
              <div className="contact-info-item">
             {/*   <h5 className="title-two">TRIO MANAGEMENT CONSULTANTS</h5>*/}
                <ul className="list-wrap">
                  <h4>Chennai</h4>
                  <li>
                  No: 2, Elango Street <br />
                  Ambedkar Nagar, Pattabiram,<br/>
                  Chennai – 600072, Tamil Nadu, India
                  </li>
                  <br/>
                  {/***
                  <h4>Coimbatore</h4>

                  <li>
                  No: 2, Anna Street <br />
                  Ambedkar Nagar, Pattabiram,<br/>
                  Coimbatore – 600072, Tamilnadu, India
                  </li>***/}
                  <br/>
                  <li>+91 - 98410 12134 / +91 - 98416 71160</li>
                  <li>info@triomc.co.in</li>
                </ul>
              </div>
               </div>
          </div>
        </div>
      </div>
    </section>
  );
};
